<template>
  <div class="category-filter-wrapper">
    <h4>Filters</h4>
    <input
      type="checkbox"
      name="filter-toggler"
      id="filter-toggler"
      class="hidden"
      checked
    />
    <label for="filter-toggler" class="filter-toggler"></label>
    <div
      class="category-filter-list full-width flex flex-column"
      ref="filterList"
    >
      <select-multiple
        :options="sizes"
        placeholder="Size"
        label="id"
        :multiselect="true"
        ref="selectSize"
        paraName="size"
        @updateValue="updateSizes"
      />
      <select-multiple
        :options="pantSizes"
        placeholder="Pants length"
        label="id"
        :multiselect="false"
        ref="selectPantSize"
        paraName="pantSize"
        @updateValue="updatePantSizes"
      />
      <div class="select-wrapper">
        <multiselect
          v-model="value"
          label="title"
          track-by="title"
          :options="[]"
          :show-labels="false"
          :searchable="false"
          class="price-range"
          paraName="price"
        >
          <template slot="singleLabel">
            <span
              v-if="priceMin == min && priceMax == max"
              class="text-black text-small"
              >Price</span
            >
            <span v-else class="text-black text-small bold"
              >{{ priceMin }} - {{ priceMax }}</span
            >
          </template>
          <template slot="noOptions">
            <vue-slider
              v-bind="{
                dotSize: 14,
                height: 4,
                contained: false,
                direction: 'ltr',
                data: null,
                min: min,
                max: max,
                interval: 10,
                tooltip: 'always',
                tooltipFormatter: currencyFormatter,
                tooltipPlacement: ['bottom', 'top'],
              }"
              v-model="priceRange"
              @drag-end="selectRange"
              ref="priceSlider"
            />
          </template>
        </multiselect>
      </div>
      <select-multiple
        :options="brands"
        placeholder="Brand"
        :multiselect="true"
        ref="selectBrand"
        paraName="brand"
        @updateValue="updateBrands"
      />
      <select-multiple
        :options="colors"
        placeholder="Color"
        label="label"
        :multiselect="true"
        ref="selectColors"
        paraName="color"
        @updateValue="updateColors"
      />
      <select-multiple
        :options="seasons"
        placeholder="Seasons"
        label="label"
        :multiselect="true"
        ref="selectTags"
        paraName="tag"
        @updateValue="updateTags"
      />
      <div
        class="flex flex-justify-center align-center vertical-align natural-fibers small-margin-bottom clickable"
        @click="toggleNaturalFibers"
      >
        <label
          class="custom-check no-margin clickable"
        >
          <svg-file :name="'tick'" v-show="naturalFibers"></svg-file>
        </label>
        <span class="flex-grow small-padding-left">
          Natural Fibers
        </span>
      </div>

      <button @click="clearFilter" v-if="showClear">
        Clear
      </button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Multiselect from 'vue-multiselect'
import SelectMultiple from '../SelectMultiple.vue'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

import { mapActions } from 'vuex'

export default {
  name: 'ProductFilter',
  components: {
    Multiselect,
    SelectMultiple,
    VueSlider
  },
  data: () => ({
    colors: [],
    brands: [],
    sizes: [42, 44, 46, 48, 50, 52, 54, 56].map((x) => {
      return { id: x, value: x }
    }),
    naturalFibers: false,
    seasons: ['Season / All year', 'Season / Spring and summer', 'Season / Fall and winter'].map((x) => {
      return { id: x.split(' ').join('').toLowerCase(), label: x }
    }),
    pantSizes: [30, 32, 34].map((x) => {
      return { id: x, value: x }
    }),
    priceRange: [0, 3500],
    sizeRange: [42, 56],
    min: 0,
    max: 3500,

    value: {},
    showClear: false,
    currencyFormatter: (v) => Vue.options.filters.toCurrency(v)
  }),
  created () {
    Vue.api.get(
      '/color',
      {},
      {
        callback: (res) => {
          this.colors = res
        }
      }
    )
    Vue.api.get(
      '/brand',
      {},
      {
        callback: (res) => {
          this.brands = res
        }
      }
    )
    this.$nextTick(() => {
      if (window.innerWidth < 768) this.show = false
    })

    if (this.$store.state.products !== undefined) {
      this.min = Object.values(this.$store.state.products).reduce((prev, curr) =>
        prev.price.regular_price <= curr.price.regular_price ? prev : curr
      ).price.regular_price
      this.min = Math.floor(this.min / 10) * 10
      this.max = Object.values(this.$store.state.products).reduce((prev, curr) =>
        prev.price.regular_price >= curr.price.regular_price ? prev : curr
      ).price.regular_price
      this.max = Math.ceil(this.max / 10) * 10

      this.priceRange = [this.min, this.max]
    }
  },
  computed: {
    priceMin: {
      get: function () {
        return this.priceRange[0]
      },
      set: function (val) {
        this.priceRange[0] = val
      }
    },
    priceMax: {
      get: function () {
        return this.priceRange[1]
      },
      set: function (val) {
        this.priceRange[1] = val
      }
    },
    sizeMin () {
      return this.sizeRange[0]
    },
    sizeMax () {
      return this.sizeRange[1]
    },
    selectedSizes: {
      get: function () {
        return this.$refs.selectSize.value
      },
      set: function (val) {
        this.$refs.selectSize.value = val
      }
    },
    selectedPantSizes: {
      get: function () {
        return this.$refs.selectPantSize.value
      },
      set: function (val) {
        this.$refs.selectPantSize.value = val
      }
    },
    selectedBrands: {
      get: function () {
        return this.$refs.selectBrand.value
      },
      set: function (val) {
        this.$refs.selectBrand.value = val
      }
    },
    selectedColors: {
      get: function () {
        return this.$refs.selectColors.value
      },
      set: function (val) {
        this.$refs.selectColors.value = val
      }
    },
    selectedTags: {
      get: function () {
        return this.$refs.selectTags.value
      },
      set: function (val) {
        this.$refs.selectTags.value = val
      }
    }
  },
  methods: {
    selectRange () {
      this.$emit('updateFilter', { label: 'min_price', value: this.priceMin })
      this.$emit('updateFilter', { label: 'max_price', value: this.priceMax })
      // { field: 'size_min', value: this.sizeMin },
      // { field: 'size_max', value: this.sizeMax },
      this.showClear = true
    },
    updateSizes (value) {
      this.$emit('updateFilter', {
        label: 'sizes',
        value: value.map((x) => x.id)
      })
      this.showClear = true
    },
    updatePantSizes (value) {
      this.$emit('updateFilter', {
        label: 'pantSizes',
        value: value.value
      })
      this.showClear = true
    },
    updateBrands (value) {
      this.$emit('updateFilter', {
        label: 'brands',
        value: value.map((x) => x.id)
      })
      this.showClear = true
    },
    updateColors (value) {
      this.$emit('updateFilter', {
        label: 'colors',
        value: value.map((x) => x.id)
      })
      this.showClear = true
    },
    updateTags (value) {
      this.$emit('updateFilter', {
        label: 'tags',
        value: value.map((x) => x.label)
      })
      this.showClear = true
    },
    toggleNaturalFibers () {
      if (this.naturalFibers) {
        this.$emit('updateFilter', {
          label: 'material',
          value: []
        })
        this.$emit('updateFilter', {
          label: 'material_percentage',
          value: ''
        })
        this.showClear = false
      } else {
        this.$emit('updateFilter', {
          label: 'material',
          value: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]
        })
        this.$emit('updateFilter', {
          label: 'material_percentage',
          value: 70
        })
        this.showClear = true
      }
      this.naturalFibers = !this.naturalFibers
    },
    clearFilter () {
      this.selectedSizes = []
      this.selectedBrands = []
      this.selectedTags = []
      this.priceMin = 0
      this.priceMax = 3500
      this.selectedColors = []
      this.selectedPantSizes = false
      this.naturalFibers = false

      this.showClear = false

      this.$emit('clearFilter')
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="less" scoped>
.category-filter-wrapper {
  position: relative;
  padding: 10px;

  .filter-toggler {
    position: absolute;
    top: 30px;
    right: 30px;

    &::after {
      content: "Collapse";
      font-size: 12px;
      font-weight: 500;
      // text-decoration: underline;
      cursor: pointer;
      border: 1px solid #aaa;
    }
  }

  .category-filter-list {
    transition: all 0.4s ease;
  }
  #filter-toggler:checked ~ .category-filter-list {
    max-height: 0;
    overflow: hidden;
  }
  #filter-toggler:checked ~ .filter-toggler {
    &::after {
      content: "Expand";
    }
  }
}

/deep/.select-wrapper {
  padding: 5px 0px;
  padding-top: 0;
}

/deep/input[type="text"] {
  padding: 0;
  border: 0;
}

/deep/.vue-slider {
  &-process {
    background-color: #4a5d5c;
  }

  &-dot-tooltip-inner {
    background: #4a5d5c;
    border-color: #4a5d5c;
  }
}

.price-range {
  /deep/.multiselect__content-wrapper {
    height: 100px;
    width: 100%;
    padding: 30px 20px 20px;
  }
}

.natural-fibers {
  margin-top: 5px;
}

.custom-check {
  display: flex;
  width: 25px;
  height: 25px;
  justify-content: center;
  align-items: center;
  border: 1px solid;
}
</style>
